import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/procurement/VendorPaymentsReport.jsx.
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'pending_approval', label: 'Pending Approval' },
  { value: 'approved_for_payment', label: 'Approved for Payment' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'cancelled', label: 'Cancelled' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'pv_number', label: 'PV #' },
  { key: 'vendor_name', label: 'Vendor' },
  { key: 'invoice_number', label: 'Invoice #' },
  { key: 'invoice_amount', label: 'Invoice Amount', align: 'right', type: 'money' },
  { key: 'payment_amount', label: 'Payment Amount', align: 'right', type: 'money' },
  { key: 'status', label: 'Status' },
  { key: 'payment_date', label: 'Paid On' },
  { key: 'payment_method', label: 'Method' },
  { key: 'bank_reference', label: 'Bank Ref' },
];

export function VendorPaymentsReport() {
  return (
    <ReportView
      title="Vendor Payment Voucher Register"
      description="Payment vouchers and their settlement status per vendor invoice."
      endpoint="/reports/procurement/vendor-payments"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
